// TODO: these need to be updated when we add the new colours
// to the design-tokens

export const TEAL_100 = '#E7F9FA';
export const TEAL_600 = '#11C6CF';
export const TEAL_700 = '#0B8A90';
